// extracted by mini-css-extract-plugin
export default {"cards":"pRpm6Fh8zHLIgP1IEBgG","card":"dczr3aKpf84KpvlobQKD","h4":"AS8SoVLMrfAC1qbmGoZ4","body":"LZRNyOfPPCvfxxtDmVd3","image":"Aq5K0ceOd67SueJzDv1w"};